import './keyThinkers.css'
import ornamentsImg from '../../../../assets/img/libro/flores_horiz.png'

const KeyThinkers = () => {
  return (
    <section className="keyThinkers">

      {/* ORNAMENTOS SUPERIORES */}
      <div className="keyThinkers__ornaments">
        <img src={ornamentsImg} alt="" />
        <img src={ornamentsImg} alt="" />
      </div>

      <div className="keyThinkers__container section__padding">

          <p className="keyThinkers__listTitle">
            Autoras, investigadoras y profesionales que inspiran este libro
          </p>

        <p className="keyThinkers__intro">
          Educación menstrual es un libro creado desde el reconocimiento a mujeres referentes para sus autoras, cuyo conocimiento y saberes atraviesan y sostienen esta obra. 
        </p>

        <div className="keyThinkers__list">          

          <p>
           <strong>Eugenia Tarzibachi</strong> — Psicóloga, psicoterapeuta y Doctora en Ciencias sociales. Estudios sobre menstruación, género y poder.
          </p>
          <p>
            <strong>Laura Medina Perucha</strong>  — Psicóloga e investigadora especializada en salud y justicia menstrual.
          </p>
          <p>
            <strong>Chris Bobel</strong>  — Profesora de Estudios de Mujeres, Género y Sexualidad. Estudios críticos sobre menstruación y activismos menstruales.
          </p>
          <p>
            <strong>Carme Valls Llobet</strong>  — Médica endocrinóloga. Salud de las mujeres y sesgos de género y sexo en la medicina.
          </p>
          <p>
            <strong>Anna Salvia Ribera</strong> — Psicóloga en educación sexual. Escritora de libros de educación sexual y menstrual.  
          </p>
          <p>
            <strong>Pabla San Martín</strong>  — Investigadora, escritora y partera tradicional.
          </p>
        </div>

      </div>
    </section>
  )
}

export default KeyThinkers
